<template>
<div class="background-03">

  <v-layout row wrap>
    <v-flex xs12 sm2 md1 class="hidden-xs-only aligner">
      <image-app class="animated fadeInLeft" :imaSize="50" imaSrc="contenido/diapositiva_54" imaAlt=""></image-app>
    </v-flex>
    <v-flex xs12 sm9 class="animated fadeInUp dura_1">
      <h1 class="big-font font-red davi-curs">Tips</h1>
    </v-flex>
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc :vidTittle="'¡Felicitaciones, ha creado su patrimonio!'" videoEmbed="ADMINISTRACIONDINERO55Tipsb.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex xs12 class="light-dark-int">
      <p>
        Los cambios positivos en las finanzas personales y familiares se logran si se realizan los siguientes ejercicios de forma periódica. Haciendo clic sobre los números podrá descubrir un nuevo tip:</p>
    </v-flex>
  </v-layout>

  <v-layout row wrap class="adorn-bottom" mb-5>
    <bots-numbers-bottom :numeroBotones="6">
      <div v-for="(item, index) in textos" :slot="'cont'+index">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm3 md2 lg2 text-xs-center>
            <ui-circle-span class="animated rotateIn" :botProp="[index+1, '', 'back-red']" :aria="'numero '+(index+1)"></ui-circle-span>
          </v-flex>
          <v-flex xs12 sm9 md8 lg7 class="animated fadeInRight">
            <p>{{item}}</p>
          </v-flex>
        </v-layout>
      </div>
    </bots-numbers-bottom>
  </v-layout>

</div>
</template>

<script>
export default {
  data() {
    return {
      textos: [
        'Hacer un presupuesto mensual y revisarlo periódicamente, siendo muy crítico con los gastos realizados.',
        'Identificar los gastos discrecionales no requeridos. La clave para una buena administración financiera está en la correcta administración de los gastos.',
        'Decidir de manera consciente cada gasto nuevo a realizar. ¿Es necesario o es un antojo? ',
        'Tomar el ahorro como una disciplina, así sea con una cifra pequeña. Siempre incluya en el presupuesto una porción del ingreso para ahorrarlo.',
        'Tener presente los gastos asociados a los bienes que se tienen.  En ocasiones los bienes generan demasiados gastos. Se debe tener equilibrio entre los bienes que producen satisfacción y las inversiones que logran sostenibilidad.',
        'Pensar siempre en el futuro y no vivir sólo el presente.  Del ahorro, las inversiones y del control de sus gastos depende su bienestar futuro.',
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-55.vue?75d5e072